import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { AUIModal } from '@ancert/aui-modal';
import { ReactComponent as IconWarning } from '../../../../assets/images/ic-warning.svg';
import './ModalAdvertenciaDescarga.scss';

/**
 * Modal para mostrar advertencia antes de descargar
 * @param {Object} props - Props del componente
 * @param {boolean} props.show - Controla si el modal está visible
 * @param {function} props.onClose - Función para cerrar el modal (cancelar)
 * @param {function} props.onConfirm - Función para confirmar y proceder con la descarga
 * @returns {React.ReactElement} - Componente ModalAdvertenciaDescarga
 */
const ModalAdvertenciaDescarga = ({ show, onClose, onConfirm }) => {
  const { t } = useTranslation();
  return (
  <AUIModal
    autoHeight
    size="xs"
    show={show}
    title={t('modalAdvertenciaDescarga.title')}
    className="modal-advertencia-descarga"
    actionButtons={[
      {
        id: 'confirm',
        mode: 'primary',
        label: t('okButton'),
        onClick: onConfirm,
        disabled: false,
      },
       {
        id: 'cancel',
        mode: 'tertiary',
        label: t('cancelButton'),
        onClick: onClose,
        disabled: false,
      },
    ]}
    onClose={onClose}
  >
    <div className="modal-content">
      <IconWarning />
      <p>
        <Trans i18nKey="modalAdvertenciaDescarga.desc"
        components={{ strong:  <strong /> }}
        />
      </p>
    </div>
  </AUIModal>
);
};

ModalAdvertenciaDescarga.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ModalAdvertenciaDescarga;

